// extracted by mini-css-extract-plugin
module.exports = {"CSO_patient_content":"patient_CSO_patient_content__1IBli"};